export default {
  API_PREFIX: '/vergleich',
};
